module.exports = __webpack_public_path__ + "static/media/wings eIP wireframe.7c5e7c40.png";